@if (authService.authState().isLoggedIn) {
  <app-navbar></app-navbar>
}

<router-outlet></router-outlet>